var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('vs-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.userRoot)?_c('vs-tab',{attrs:{"label":"Cuentas Bancarias"},on:{"click":function($event){return _vm.MenuSelectedLocalStorage()}}},[_c('cuentasBanco')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }